import { render, staticRenderFns } from "./org.vue?vue&type=template&id=9c4bdc58&scoped=true&"
import script from "./org.vue?vue&type=script&lang=js&"
export * from "./org.vue?vue&type=script&lang=js&"
import style0 from "./org.vue?vue&type=style&index=0&id=9c4bdc58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4bdc58",
  null
  
)

export default component.exports